import i18n from "@/plugins/i18n";

export default function msgCodes(response: number): any {
  switch (response) {
    case 500:
      return i18n.t('misc.invalidTrunkNumber');
    case 501:
      return i18n.t('misc.invalidNumber');
    case 502:
      return i18n.t('misc.invalidMaxContacts');
    case 503:
      return i18n.t('misc.invalidCallGroup');
    case 504:
      return i18n.t('misc.invalidPassVoicemail');
    case 505:
      return i18n.t('misc.invalidPortType');
    case 506:
      return i18n.t('misc.invalidSpy');
    case 507:
      return i18n.t('misc.invalidOnBusy');
    case 508:
      return i18n.t('misc.invalidAction');
    case 509:
      return i18n.t('misc.invalidEnabled');
    case 510:
      return i18n.t('misc.invalidPassword');
    case 511:
      return i18n.t('misc.invalidDescription');
    case 512:
      return i18n.t('misc.invalidTrunkNumber');
    case 513:
      return i18n.t('misc.invalidOuter');
    case 514:
      return i18n.t('misc.invalidUsername');
    case 551:
      return i18n.t('misc.extensionExists');
    case 400:
      return i18n.t('misc.invalidExtension');
    case 550:
      return i18n.t('misc.extensionLimitReached');
    case 555:
      return i18n.t('misc.invalidQueue');
    case 556:
      return i18n.t('misc.invalidTimeExten');
    default:
      return i18n.t('misc.defaultError');
  }
}
